import styles from './RecommendationPage.module.scss';
import XCloseIcon from 'components/icons/XCloseIcon';
import { FilterSelectionField } from './types';

type FilterMobileChipsProps = {
  planType: string;
  activeNetworks: string[];
  activeCarriers: string[];
  activeLetters: string[];
  onRemove: (field: FilterSelectionField, value: string) => void;
  onReset: () => void;
  formatLetterLabel?: (value: string) => string;
};

const FilterMobileChips = ({
  planType,
  activeNetworks,
  activeCarriers,
  activeLetters,
  onRemove,
  onReset,
  formatLetterLabel,
}: FilterMobileChipsProps) => {
  if (
    activeNetworks.length === 0 &&
    activeCarriers.length === 0 &&
    activeLetters.length === 0
  ) {
    return null;
  }

  const renderChips = (
    selections: string[],
    field: FilterSelectionField,
    formatLabel?: (value: string) => string
  ) =>
    [...selections].sort().map((value, idx) => (
      <button
        key={idx}
        className={styles.chip}
        onClick={() => onRemove(field, value)}
      >
        {formatLabel ? formatLabel(value) : value}
        <XCloseIcon />
      </button>
    ));

  return (
    <div className={styles.filterWrapper}>
      <div className={styles.selectionsHeader}>
        <p>Filtered by:</p>
        <button className={styles.resetBtn} onClick={onReset}>
          Reset filters
        </button>
      </div>
      <div className={styles.selections}>
        {planType === 'mapd' && renderChips(activeNetworks, 'networks')}
        {planType === 'gap' &&
          renderChips(activeLetters, 'letters', formatLetterLabel)}
        {renderChips(activeCarriers, 'carriers')}
      </div>
    </div>
  );
};

export default FilterMobileChips;
